// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerOrganizationType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CustomerOrganizationType implements ICustomerOrganizationType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Sole Proprietorship CustomerOrganizationType
	**/
    get SoleProprietorship(): ICustomerOrganizationType {
        return this.FromId(1);
    }
    /**
		Returns General Partnership CustomerOrganizationType
	**/
    get GeneralPartnership(): ICustomerOrganizationType {
        return this.FromId(2);
    }
    /**
		Returns Limited Partnership CustomerOrganizationType
	**/
    get LimitedPartnership(): ICustomerOrganizationType {
        return this.FromId(3);
    }
    /**
		Returns Limited Liability Partnership  CustomerOrganizationType
	**/
    get LLP(): ICustomerOrganizationType {
        return this.FromId(4);
    }
    /**
		Returns Limited Liability Limited Partnership CustomerOrganizationType
	**/
    get LLLP(): ICustomerOrganizationType {
        return this.FromId(5);
    }
    /**
		Returns Corporation  CustomerOrganizationType
	**/
    get Corporation(): ICustomerOrganizationType {
        return this.FromId(6);
    }
    /**
		Returns Non-Profit Corporation  CustomerOrganizationType
	**/
    get NonProfitCorporation(): ICustomerOrganizationType {
        return this.FromId(7);
    }
    /**
		Returns Limited Liability Company  CustomerOrganizationType
	**/
    get LLC(): ICustomerOrganizationType {
        return this.FromId(8);
    }
    /**
		Returns Joint Venture  CustomerOrganizationType
	**/
    get JointVenture(): ICustomerOrganizationType {
        return this.FromId(9);
    }
    /**
		Returns Government  CustomerOrganizationType
	**/
    get Government(): ICustomerOrganizationType {
        return this.FromId(10);
    }
    /**
		Returns Municipality  CustomerOrganizationType
	**/
    get Municipality(): ICustomerOrganizationType {
        return this.FromId(11);
    }
    /**
		Returns Association  CustomerOrganizationType
	**/
    get Association(): ICustomerOrganizationType {
        return this.FromId(12);
    }
    /**
		Returns Self Proclaimed  CustomerOrganizationType
	**/
    get SelfProclaimed(): ICustomerOrganizationType {
        return this.FromId(13);
    }
    /**
		Returns Trust  CustomerOrganizationType
	**/
    get Trust(): ICustomerOrganizationType {
        return this.FromId(14);
    }
    /**
		Returns Estate CustomerOrganizationType
	**/
    get Estate(): ICustomerOrganizationType {
        return this.FromId(15);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'SoleProprietorship', displayValue: 'Sole Proprietorship', description: 'Sole Proprietorship is one individual or married couple doing business alone.', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'GeneralPartnership', displayValue: 'General Partnership', description: 'General Partnership is composed of 2 or more persons who agree to contribute money, labor, or skill to a business. ', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'LimitedPartnership', displayValue: 'Limited Partnership', description: 'Limited Partnership is composed of one or more general partners and one or more limited partners', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'LLP', displayValue: 'Limited Liability Partnership ', description: 'Limited Liable Partnership is similar to a General Partnership except that normally a partner doesn`t have personal liability for the negligence of another partner.', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'LLLP', displayValue: 'Limited Liability Limited Partnership', description: 'Limited Liability Limited Partnership is a Limited Partnership that chooses to become an LLLP by including a statement to that effect in its certificate of limited partnership', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'Corporation ', displayValue: 'Corporation ', description: 'Doing business as a corporation may yield tax or financial benefits, but these can be offset by other considerations, such as increased licensing fees or decreased personal control. ', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'NonProfitCorporation ', displayValue: 'Non-Profit Corporation ', description: 'Non-Profit corporation is formed by 1 or more individuals or entities through a special written agreement.', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'LLC', displayValue: 'Limited Liability Company ', description: 'Limited Liability Company is formed by 1 or more individuals or entities through a special written agreement. ', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'JointVenture ', displayValue: 'Joint Venture ', description: 'Joint Venture is formed for a limited length of time to carry out a business transaction or operation. ', sortOrder: 10, active: true });
        this._dictionary.add('10', { id: 10, value: 'Government ', displayValue: 'Government ', description: 'A government or state agency, often an appointed commission, is a permanent or semi-permanent organization in the machinery of government that is responsible for the oversight and administration of specific functions, such as an intelligence agency', sortOrder: 11, active: true });
        this._dictionary.add('11', { id: 11, value: 'Municipality ', displayValue: 'Municipality ', description: 'A Municipality is a public corporation established as a subdivision of a state for local governmental purposes.', sortOrder: 12, active: true });
        this._dictionary.add('12', { id: 12, value: 'Association ', displayValue: 'Association ', description: 'Association is an organized group of people who share in a common interest, activity, or purpose. ', sortOrder: 13, active: true });
        this._dictionary.add('13', { id: 13, value: 'SelfProclaimed ', displayValue: 'Self Proclaimed ', description: 'Described as or proclaimed to be such by oneself, without endorsement by others.', sortOrder: 14, active: true });
        this._dictionary.add('14', { id: 14, value: 'Trust ', displayValue: 'Trust ', description: 'Commercial organization managed by appointed trustees (who hold the title to the business` property) for the benefit of one or more beneficiaries.', sortOrder: 15, active: true });
        this._dictionary.add('15', { id: 15, value: 'Estate', displayValue: 'Estate', description: 'Property consisting of land and the buildings on it, along with its natural resources such as crops, minerals or water', sortOrder: 16, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerOrganizationType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerOrganizationType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerOrganizationType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerOrganizationType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerOrganizationType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
